import { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    ActiveFilter,
    activeFiltersOrder,
    ActiveFilterToFilterTabsMap,
    FilterTabs,
    isActive,
    VIRTUAL_FILTER_TABS,
} from "./lib";

export function useActiveFilters(
    filters: FiltersTypes,
    availableFilters: FilterTabs[],
): ActiveFilter[] {
    return useMemo(() => {
        const allAvailableFilters = new Set([
            ...availableFilters,
            ...VIRTUAL_FILTER_TABS,
        ]);

        return activeFiltersOrder.filter(
            (filterId) =>
                allAvailableFilters.has(
                    ActiveFilterToFilterTabsMap[filterId],
                ) && isActive[filterId](filters),
        );
    }, [availableFilters, filters]);
}
